import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react'
import { BrowserRouter as Router, Route,Switch} from "react-router-dom";
import Cookies from 'universal-cookie';
import App from './App';
import intl from 'react-intl-universal';
import zh from './i18n/zh.js'
import en from './i18n/en.js'
import en_US from './i18n/en_US.js'
import ms from './i18n/malay.js'
import de from './i18n/ger.js'
import fr from './i18n/french.js'
import it from './i18n/italian.js'
import es from './i18n/spanish.js'
import zh_TW from './i18n/tw.js'
import ja from './i18n/ja'
import pl from './i18n/pl'
import pt from './i18n/pt'
import nl from './i18n/nl'
import da from './i18n/danish'
import th from './i18n/thai'
import vi from './i18n/viet'
import ko from './i18n/ko'

import registerServiceWorker from './registerServiceWorker';
const cookies = new Cookies();
let lang = cookies.get('language')
if (lang === 'ge'){
    lang = 'de'
}else if (lang === 'sp'){
    lang = 'es'
}else if (lang === 'ma'){
    lang = 'ms'
}else if (lang === 'lt'){  
    lang = 'it'
}else if (lang === 'tw'){
    lang = 'zh_TW'
}else if (lang === 'jp'){
    lang = 'ja'
}else if (lang === 'po'){
    lang = 'pl'
}else if (lang === 'por'){
    lang = 'pt'
}else if (lang === 'dk'){
    lang = 'da'
}
let  jsSrc =(navigator.language || navigator.browserLanguage).toLowerCase();
let returnLanguage = () => {
  // jsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
  jsSrc = navigator.language || navigator.browserLanguage
  // alert(jsSrc)
  // alert(lang)
  if (jsSrc.indexOf('zh-CN') >= 0 || jsSrc.indexOf('zh-TW') >= 0) {
    return jsSrc
  }
  else
  // if (jsSrc.indexOf('zh-HK') >= 0) {
  //   return jsSrc
  // }
  // else
  if (jsSrc.indexOf('zh') >= 0 ) {
    return 'zh'
  }
  else if (jsSrc.indexOf('lt') >= 0 || jsSrc.indexOf('it') >= 0) {
    return 'it'
  }
  else if (jsSrc.indexOf('ge') >= 0 || jsSrc.indexOf('de') >= 0) {
    return 'de'
  }
  else if (jsSrc.indexOf('ma') >= 0 || jsSrc.indexOf('ms') >= 0) {
    return 'ms'
  }
  else if (jsSrc.indexOf('jp') >= 0 || jsSrc.indexOf('ja') >= 0) {
    return 'ja'
  }
  else if (jsSrc.indexOf('po') >= 0 || jsSrc.indexOf('pl') >= 0) {
    return 'pl'
  }
  else if (jsSrc.indexOf('por') >= 0 || jsSrc.indexOf('pt') >= 0) {
    return 'pt'
  }
  else if (jsSrc.indexOf('dk') >= 0 || jsSrc.indexOf('da') >= 0) {
    return 'da'
  }
  else if (jsSrc.indexOf('es') >= 0 || jsSrc.indexOf('es') >= 0) {
    return 'es'
  }
  else if (jsSrc.indexOf('en-GB') >= 0 || jsSrc.indexOf('en-US') >= 0 || jsSrc.indexOf('en-CA') >= 0) {
    return jsSrc
  }else if (jsSrc.indexOf('ko') >= 0 || jsSrc.indexOf('korean') >= 0) {
    return 'ko'
  }
  else {
    return 'en'
  }
};
intl.init({
  currentLocale: lang ? lang : returnLanguage(),
  // currentLocale: returnLanguage(),
  fallbackLocale: 'en',
  locales: {
    en,
    'en-GB':en,
    'en-US':en_US,'en-CA':en_US,    
    zh,
    'zh-CN':zh,
    'zh-TW':zh_TW,    
    ms,
    de,
    fr,
    it,
    es,    
    ja,
    pl,
    pt,
    nl,
    da,
    th,
    vi,
    ko,
  }
})

ReactDOM.render(<App />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js